import router from '@/router'
import store from '@/store'

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  if (store.getters.token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (!store.getters.user) { // 验权
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          next()
        })
      } else {
        next()
      }
    }
  } else {
    // if (whiteList.indexOf(to.path) !== -1) {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
  }
})

function getDefaultRecords () {
  return [
    { type: '产品', name: '游戏管理', meta: '关联路径: /p', timeText: '今天 10:24', path: '/p', query: {} },
    { type: '渠道', name: '渠道接入', meta: '关联路径: /c/cl', timeText: '今天 09:15', path: '/c/cl', query: {} },
    { type: '商户', name: '商户配置', meta: '关联路径: /mch/group', timeText: '昨天 17:40', path: '/mch/group', query: {} },
    { type: '参数', name: '登录支付', meta: '关联路径: /xs/args/game', timeText: '昨天 15:30', path: '/xs/args/game', query: {} },
    { type: '认证', name: '电信认证', meta: '关联路径: /xs/telecom/auth', timeText: '昨天 11:20', path: '/xs/telecom/auth', query: {} },
    { type: '渠道', name: '官包配置', meta: '关联路径: /xs/args/channel', timeText: '前天 14:10', path: '/xs/args/channel', query: {} },
    { type: '扩展', name: '扩展游戏', meta: '关联路径: /ext/config/game', timeText: '前天 10:05', path: '/ext/config/game', query: {} },
    { type: '扩展', name: '扩展渠道', meta: '关联路径: /ext/config/channel', timeText: '前天 09:30', path: '/ext/config/channel', query: {} }
  ]
}

router.afterEach((to) => {
  // 排除登录页、首页、无名路由及 404 页面
  if (to.path === '/login' || to.path === '/home' || !to.name || to.name === '404' || to.path === '*') {
    return
  }

  const username = store.getters.name || 'Admin'
  const cacheKey = `recent_records_${username}`
  let list = []
  try {
    const cached = localStorage.getItem(cacheKey)
    list = cached ? JSON.parse(cached) : getDefaultRecords()
  } catch (e) {
    list = getDefaultRecords()
  }

  const now = new Date()
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const timeText = `今天 ${hours}:${minutes}`

  // 自动从嵌套路由中解析父大类
  let parentType = '系统'
  if (to.matched && to.matched.length > 0) {
    const parentRoute = to.matched[0]
    if (parentRoute && parentRoute.name) {
      parentType = parentRoute.name
    }
  }

  // 大类精简映射
  const typeMapping = {
    渠道接入: '渠道',
    广告变现: '广告',
    环境配置: '运维',
    公司主体: '公司',
    商户配置: '商户',
    登录支付: '参数',
    扩展配置: '扩展',
    其他: '其它'
  }
  const displayType = typeMapping[parentType] || parentType

  const newRecord = {
    type: displayType,
    name: to.name,
    meta: `关联路径: ${to.path}`,
    timeText: timeText,
    path: to.path,
    query: to.query || {}
  }

  // 排重并置顶最新记录
  list = list.filter(r => r.name !== to.name)
  list.unshift(newRecord)

  // 限制记录最大展示 8 条
  if (list.length > 8) {
    list = list.slice(0, 8)
  }

  localStorage.setItem(cacheKey, JSON.stringify(list))
})
